<template>
  <div v-if="isGranted('VIEW_PERSONS')">
    <q-btn-group rounded>
      <q-btn
        icon="fa fa-users"
        :color="personIds.length ? 'primary' : undefined"
        :text-color="personIds.length ? 'white' : undefined"
        class="q-py-sm"
        @click="openPersonFilter"
      >
        <span
          v-if="personIds.length"
          class="q-ml-sm"
        >{{ personIds.length }}</span>
        <q-tooltip>Filter by People</q-tooltip>
      </q-btn>
      <q-btn
        v-if="personIds.length"
        icon="fa fa-times"
        class="q-py-sm"
        @click="$emit('update:person-ids', [])"
      >
        <q-tooltip>Clear person filter</q-tooltip>
      </q-btn>
    </q-btn-group>
    <FaceDetailDialog
      ref="faceDetail"
      :client-id="clientId"
      @view-person="openPerson"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Face } from '@/analysis/types';
import isGranted from '@/auth/isGranted';
import openModal from '@/components/modal';
import FaceDetailDialog from '@/analysis/face/FaceDetailDialog.vue';
import PersonFilterSidebar from '@/analysis/person/PersonFilterSidebar.vue';
import { openDrawer } from '@/layout';

export default defineComponent({
  emits: ['update:person-ids'],
  components: {
    FaceDetailDialog,
  },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
    personIds: {
      type: Array as () => number[],
      default: () => [],
    },
  },
  methods: {
    isGranted,
    openSidebar() {
      (this.$refs.sidebar as any).open();
    },
    openPersonFilter() {
      openDrawer({
        component: PersonFilterSidebar,
        props: {
          clientId: this.clientId,
          value: this.personIds,
        },
        on: {
          'update:value': (ids: number[]) => {
            this.$emit('update:person-ids', ids);
          },
        },
        paddless: true,
        closable: false,
      });
    },
    onPersonIdsChange(ids: number[]) {
      this.$emit('update:person-ids', ids);
    },
    onFaceClick(face: Face) {
      (this.$refs.faceDetail as any).open(face);
    },
    async openPerson(person: any, callback: () => void) {
      const { default: PersonDetailDialog } = await import('@/analysis/person/PersonDetailDialog.vue');
      openModal(PersonDetailDialog, {
        parent: this,
        clientId: this.clientId,
        person,
      });
      callback();
    },
  },
});
</script>
